export const auctionPrice = (a) => {
  const elapsed = Math.max(0, (Date.now() - new Date(a.started_at)) / 1000);
  const drops = Math.floor(elapsed / a.interval_seconds);
  return Math.max(a.floor_price, Math.round((a.start_price - drops * a.drop_amount) * 100) / 100);
};

export const auctionStartsIn = (a) => Math.max(0, Math.ceil((new Date(a.started_at) - Date.now()) / 1000));

export const nextDropIn = (a) => {
  const elapsed = Math.max(0, (Date.now() - new Date(a.started_at)) / 1000);
  return Math.ceil(a.interval_seconds - (elapsed % a.interval_seconds));
};

export const fmtSecs = (s) => {
  if (s >= 3600) return `${Math.floor(s / 3600)}H ${Math.floor((s % 3600) / 60)}M`;
  if (s >= 60) return `${Math.floor(s / 60)}M ${s % 60}S`;
  return `${s}S`;
};

